// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__C6tRc","col":"styles_col__-JPTw","fulfillmentStatus":"styles_fulfillmentStatus__14JTz","emailCol":"styles_emailCol__2wbzL"};